import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { getClientStripeData } from "../api/stripe/clientKey";
import { getClientKeySuccess, getClientKeyFailure } from "../actions/stripe/getClientKeyAction";

const StripeKeyContext = createContext({ stripePromise: null, publishableKey: null });

export const useStripeKey = () => useContext(StripeKeyContext);

export const StripeKeyProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [publishableKey, setPublishableKey] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const shopId = queryParams.get("client_id") || localStorage.getItem("clientId");
    if (!shopId) {
      return;
    }

    getClientStripeData({ shopId })
      .then((response) => {
        dispatch(getClientKeySuccess(response.data));
        const key = response?.data?.data?.api_id;
        if (key) {
          setPublishableKey(key);
        }
      })
      .catch((error) => {
        dispatch(getClientKeyFailure(error.message));
      });
  }, [dispatch]);

  const stripePromise = useMemo(
    () => (publishableKey ? loadStripe(publishableKey) : null),
    [publishableKey]
  );

  return (
    <StripeKeyContext.Provider value={{ stripePromise, publishableKey }}>
      {children}
    </StripeKeyContext.Provider>
  );
};
